export default function organizationsettings(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                organizationsetting: action.organizationsetting,

            }
        case 'ADD_CURRENT_ORGANIZATION':
            return {
                ...state,
                organizationsetting: action.organizationsetting,
                organization: action.organization,

            }
        default:
            return state;
    }
}
